export const BETA_WELCOME_KEY = "dh_beta_welcome_";
export const BETA_DESK_HINT_KEY = "dh_beta_desk_hint_";
export const BETA_WELCOME_CLOSED = "dh-beta-welcome-closed";

export function betaWelcomeKey(userId) {
  return `${BETA_WELCOME_KEY}${userId}`;
}

export function betaDeskHintKey(userId) {
  return `${BETA_DESK_HINT_KEY}${userId}`;
}

export function hasSeenBetaWelcome(userId) {
  if (!userId) return true;
  try {
    return Boolean(localStorage.getItem(betaWelcomeKey(userId)));
  } catch {
    return false;
  }
}

export function markBetaWelcomeSeen(userId) {
  if (!userId) return;
  try {
    localStorage.setItem(betaWelcomeKey(userId), "1");
  } catch {
    /* ignore */
  }
  if (typeof window !== "undefined") {
    window.dispatchEvent(new Event(BETA_WELCOME_CLOSED));
  }
}

export function hasSeenDeskHint(userId) {
  if (!userId) return true;
  try {
    return Boolean(localStorage.getItem(betaDeskHintKey(userId)));
  } catch {
    return false;
  }
}

export function markDeskHintSeen(userId) {
  if (!userId) return;
  try {
    localStorage.setItem(betaDeskHintKey(userId), "1");
  } catch {
    /* ignore */
  }
}
